import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import SideNav from './Partials/SideNav';
import { qprService } from '../../../../Services';
import { qprActions } from '../../../../Actions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

const ResearchBackgroundForm = () => {
  const location = useLocation();
  const { qpr_id, qh } = location.state;
  const qpr = useSelector((state) => state.qpr_data);
  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const [drafted, setDrafted] = useState(false);

  const [input, setInput] = useState(qpr.research_background && qpr.research_background.research_objective !== undefined? qpr.research_background: {
    research_objective: '',
    expected_outcome: '',
    deviation: '',
  });

  useEffect( () => {
    if(typeof qpr.research_background == "undefined") {
      qprService.researchBackground(qpr_id).then(rslt => {
        Object.keys(rslt.data.research_background).map(val => {
          rslt.data.research_background[val] = rslt.data.research_background[val] ?? "";
        });
        qpr.research_background = rslt.data.research_background;
        qpr.form_validation = JSON.parse(rslt.data.research_background.form_validation);
        localStorage.setItem("qpr_data", JSON.stringify(qpr));
        dispatch(qprActions.qprData(qpr));
        setInput(qpr.research_background);
      });
    }
  }, []);

  const [validationError, setValidationError] = useState({});
  const ref = useRef([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const checkValidation = () => {
    let error = {};
    Object.keys(input).map(item => {
      if(!input[item] && item != "user_status") {
        error[item] = "Required";
      }
    });

    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const submitForm = (submit_status, fnctn) => {
    setValidationError({});
    qpr.form_validation.research_background.submit_status = 0;
    input.submit_status = 0;
    if(submit_status == 1) {
      input.submit_status = 1;
      if(Object.keys(checkValidation()).length > 0) {
        fnctn(false);
        return false;
      }
      qpr.form_validation.research_background.submit_status = 1;
    }
    input.form_validation = JSON.stringify(qpr.form_validation);
    qprService.researchBackgroundSave(input, qpr_id).then(rslt => {
      Object.keys(rslt.data.research_background).map(val => {
        rslt.data.research_background[val] = rslt.data.research_background[val] ?? "";
      });
      qpr.research_background = rslt.data.research_background;
      localStorage.setItem("qpr_data", JSON.stringify(qpr));
      dispatch(qprActions.qprData(qpr));
      fnctn(false);
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let submit_status = e.target.dataset.submit_status;
    let fnctn = submit_status==1? setSubmitted: setDrafted;
    fnctn(true);
    submitForm(submit_status, fnctn);
  }
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>{qh}</h5>
              </div>
              <div className='row mt-4'>
                <div className='col-md-4'>
                  <SideNav />
                </div>
                <div className='col-md-8'>
                  <div className='card border-info' style={{"borderTop": "3px solid"}}>
                    <div className='card-header'><h6>Research Background</h6></div>
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-submit_status={1}>
                          <div className="singel-form">
                            <label>Research Objectives (Not more than 150 words)<span className='text-danger'>*</span>:</label>
                            <textarea name='research_objective' value={input.research_objective} ref={r => {ref.current['research_objective'] = r}} onChange={handleChange} data-error="Research objective is required" ></textarea>
                            {validationError.research_objective && <span className='text-danger'>{validationError.research_objective}</span>}
                          </div>
                          <div className="singel-form">
                            <label>Expected Outcomes of Research (Not more than 150 words)<span className='text-danger'>*</span>:</label>
                            <textarea name='expected_outcome' value={input.expected_outcome} ref={r => {ref.current['expected_outcome'] = r}} onChange={handleChange} data-error="Expected outcomes of research is required" ></textarea>
                            {validationError.expected_outcome && <span className='text-danger'>{validationError.expected_outcome}</span>}
                          </div>
                          <div className="singel-form">
                            <label>Deviation/changes if any from the original proposal (Not more than 150 words)<span className='text-danger'>*</span>:</label>
                            <textarea name='deviation' value={input.deviation} ref={r => {ref.current['deviation'] = r}} onChange={handleChange} data-error="Deviation is required" ></textarea>
                            {validationError.deviation && <span className='text-danger'>{validationError.deviation}</span>}
                          </div>
                          <hr/>
                          <p className="form-message"></p>
                          <div className="singel-form">
                            <button type="button" className="main-btn btn-info btn-outline-info disabled" onClick={submitted? '': handleSubmit} data-tip data-for="draft">
                              {drafted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Draft</span>}
                            </button>
                            <ReactTooltip id="draft" place="top" effect="solid">
                              You can save the form as draft if you do not have all the required information to fill
                            </ReactTooltip>
                            <button type={submitted? "button": "submit"} className="main-btn btn-info ml-3 disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Save</span>}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResearchBackgroundForm;